function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h56v87H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 70c15.464 0 28-12.536 28-28S30.464 14 15 14v56z",
  fill: "#0278C7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30 49l-6-6.5 6-6.5",
  stroke: "#fff",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCollapseSidebarButton = function SvgCollapseSidebarButton(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 87,
    viewBox: "0 0 56 87",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml,%3Csvg width='56' height='87' viewBox='0 0 56 87' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='56' height='87' fill='none'/%3E %3Cpath d='M15 70C30.464 70 43 57.464 43 42C43 26.536 30.464 14 15 14V70Z' fill='%230278C7'/%3E %3Cpath d='M30 49L24 42.5L30 36' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";
export { SvgCollapseSidebarButton as ReactComponent };